import script from "./CheckConnection.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckConnection.vue?vue&type=script&setup=true&lang=ts"

import "./CheckConnection.vue?vue&type=style&index=0&id=740b3f51&lang=scss"

const __exports__ = script;

export default __exports__